<script>
const ComponentEvent = {
	deleteItem: 'deleteItem',
	downloadItem: 'downloadItem'
};

/**
 *
 * @version 1.0.0
 * @since
 */
export default {
	name: 'VMedicalDocumentsUploadItem',
	components: {},
	emits: {
		deleteItem: null,
		downloadItem: null,
	},
	props: {
		name: {
			required: true,
			type: String,
		},
		infoList: {
			required: false,
			type: Array,
			default: () => [],
		},
		deleteUrl: {
			required: false,
			type: String,
			default: () => '',
		},
		enableLocalDelete: {
			required: false,
			type: Boolean,
			default: () => false,
		},
		error: {
			required: false,
			type: String,
			default: () => '',
		},
		isLoading: {
			required: false,
			type: Boolean,
			default: () => false,
		},
		modalId: {
			required: true,
			type: String,
		}
	},
	setup() {
		return {
			ComponentEvent,
		};
	},
};
</script>

<template>
    <div class="uploaded-document-card">
        <div class="uploaded-document-card__content">
            <p class="uploaded-document-card__content-label">{{ name }}</p>
            <div class="separator--dot separator--dot-gray uploaded-document-card__content-info">
                <span>{{ infoList[0] }}</span>
                <span>{{ infoList[1] }}</span>
            </div>
        </div>
        <div class="uploaded-document-card__buttons">
            <button
								:disabled="enableLocalDelete"
                @click="$emit(ComponentEvent.downloadItem)"
                class="button download-document-button"
            >
                <svg class="icon" role="img">
                    <use xlink:href="#icon-downloads"></use>
                </svg>
            </button>
            <button
                class="button remove-document-button"
                @click="$emit(ComponentEvent.deleteItem)"
								:data-micromodal-trigger="modalId"
                type="button"
            >
                <svg class="icon" role="img">
                    <use xlink:href="#icon-close"></use>
                </svg>
            </button>
        </div>
    </div>
    <p v-if="error" class="upload__document-info error">
        {{ error }}
    </p>
</template>
